import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
    private _loading = new BehaviorSubject<boolean>(false);
    public readonly loading$ = this._loading.asObservable();

    // Contador para manejar peticiones concurrentes correctamente
    private requestCount = 0;

    show(): void {
        this.requestCount++;
        if (!this._loading.value) {
            this._loading.next(true);
        }
    }

    hide(): void {
        this.requestCount = Math.max(this.requestCount - 1, 0);
        if (this.requestCount === 0) {
            this._loading.next(false);
        }
    }
}
